export default "__VITE_ASSET__bbb4dedd__"